import {action, computed} from "mobx";

import {Permission} from "../../../stores/authentication-store";
import {DatabaseRecordBasePageStore} from "../../../stores/database-template/database-record-base-store";
import {PageStoreConstructorOptions} from "../../../utils/page-store";

// 新規作成と編集ページで共通のロジックを持つベースストアを継承
export class DatabaseTemplateRecordCreatePageStore extends DatabaseRecordBasePageStore {
    constructor(options: PageStoreConstructorOptions) {
        super(options);
    }

    public async initialize({query}: {query: {mediaId: string; templateId: string}}) {
        this.stores.authenticationStore.checkAnyPermissionExists(Permission.EDIT_GENERAL_RESOURCES);
        this.setMediaId(query.mediaId);
        this.setTemplateId(query.templateId);
        await this.loadTemplate();
    }

    @action.bound
    public async createTemplateItemRecord() {
        const dto = this.buildUpsertDto();
        try {
            await this.adminApi.postTemplateItem(
                {mediaId: this.mediaId},
                {templateId: this.templateId},
                dto,
            );
        } catch (error) {
            console.error("Error creating template record:", error);
        }
        this.pageRouter.pushRoute(
            `/admin/${this.mediaId}/database-templates/detail/${this.templateId}?tab=management`,
        );
    }
    @computed
    public get canCreate() {
        return this.canSave();
    }
}
